/* Find your trailer: brand chip plus one summary pill.

   The app extension builds the bar by replacing innerHTML on every state
   change, so this cannot decorate once and walk away. It observes the bar and
   re-applies after each render. The restructure is minimal: the brand chip
   moves into the card, the other three move as a group into a sheet wrapper,
   and the summary pill is injected. Every chip is still the extension's own
   button with its own menu, so nothing it listens for is disturbed.

   Order matters. Resolve every node reference against the live document BEFORE
   moving anything: a chip moved into a detached container is no longer findable
   from the bar, which is how the first cut of this threw and ate the brand chip.

   WHY THE BRAND SWITCH IS ANIMATED IN JS AND NOT IN CSS. .fx-pb__card carries
   transitions for background, border and radius, and none of them ever ran:
   switching brand makes the extension rebuild the bar's children, so the card
   the transition was declared on no longer exists by the time the new colours
   apply. A brand new element renders in its final state, instantly, by
   definition. The fix is to notice that the brand CHANGED rather than merely
   rendered, and play a short entrance on the replacement. lastBrand is what
   tells those two apart, which is also why the first render never animates.

   It writes exactly one thing: fxTrailerPick, when someone commits a model with
   Find Parts. The header button needs to know a trailer was chosen by model,
   and the extension only records VIN searches. */
(function () {
  var BAR = '[data-ident-pickbar]';
  var PICK_KEY = 'fxTrailerPick';
  var SWAP_MS = 460;
  var CHEV =
    '<svg viewBox="0 0 11 7" fill="none" aria-hidden="true">' +
    '<path d="M1 1l4.5 5L10 1" stroke="currentColor" stroke-width="1.7"' +
    ' stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function marks() {
    var tpl = document.getElementById('fx-marks');
    if (!tpl || !tpl.content) return null;
    var frag = tpl.content.cloneNode(true);
    var svgs = frag.querySelectorAll('svg');
    if (!svgs.length) return null;
    var wrap = document.createElement('span');
    wrap.className = 'fx-pb__marks';
    [].forEach.call(svgs, function (s) { wrap.appendChild(s); });
    return wrap;
  }

  function chipFor(root, key) {
    return root.querySelector('[data-ident-chip="' + key + '"]');
  }

  function valueOf(root, key) {
    var chip = chipFor(root, key);
    if (!chip) return '';
    var val = chip.querySelector('.ident-selchip-val');
    return val ? val.textContent.trim() : '';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function labelHtml(root) {
    var range = valueOf(root, 'range');
    var model = valueOf(root, 'model');
    var year = valueOf(root, 'year');
    var html = '';
    if (range) {
      html += '<span class="fx-pb__pt fx-pb__pt--range">' + esc(range) +
        '<i class="fx-pb__sep">&middot;</i></span>';
    }
    html += '<span class="fx-pb__pt fx-pb__pt--model">' + esc(model) + '</span>';
    if (year) {
      html += '<span class="fx-pb__pt fx-pb__pt--year">' +
        '<i class="fx-pb__sep">&middot;</i>' + esc(year) + '</span>';
    }
    return html;
  }

  function brandOf(chip) {
    if (!chip) return 'futura';
    if (chip.querySelector('.ident-selchip-logo--shiftr')) return 'shiftr';
    var label = (chip.getAttribute('aria-label') || '').toUpperCase();
    return label.indexOf('SHIFTR') > -1 ? 'shiftr' : 'futura';
  }

  var animTimer = null;
  var swapTimer = null;
  var lastBrand = null;

  function decorate() {
    var bar = document.querySelector(BAR);
    if (!bar) return;
    // Already done for this render. The observer fires on our own writes too,
    // so this guard is what stops the loop.
    if (bar.querySelector('.fx-pb__card')) return;

    // Resolve everything against the live tree first.
    var brandChip = chipFor(bar, 'brand');
    if (!brandChip) return;
    var brandWrap = brandChip.closest('.ident-selwrap');
    if (!brandWrap || brandWrap.parentNode !== bar) return;
    var brand = brandOf(brandChip);
    var lab = labelHtml(bar);
    var mk = marks();
    var logo = brandChip.querySelector('.ident-selchip-logo');
    var rest = [].filter.call(bar.children, function (n) {
      return n.classList.contains('ident-selwrap') && n !== brandWrap;
    });

    bar.classList.add('fx-pb');

    // Card goes in first, then the chip moves into it. The other way round
    // detaches the chip from the document and every lookup after it fails.
    var card = document.createElement('div');
    card.className = 'fx-pb__card';
    bar.insertBefore(card, bar.firstChild);
    card.appendChild(brandWrap);

    if (mk && logo && logo.parentNode) {
      logo.parentNode.replaceChild(mk, logo);
    }

    var bchev = document.createElement('span');
    bchev.className = 'fx-pb__chev';
    bchev.innerHTML = CHEV;
    brandChip.appendChild(bchev);

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'fx-pb__pill';
    pill.setAttribute('aria-expanded', 'false');
    pill.innerHTML = '<span class="fx-pb__lab">' + lab + '</span>' +
      '<span class="fx-pb__chev">' + CHEV + '</span>';
    card.appendChild(pill);

    // The other three chips become the sheet. They need a single wrapper so the
    // open and close can animate as one height, and the wrapper clips only
    // while it is moving: an open sheet has to let its dropdowns escape.
    var sheet = document.createElement('div');
    sheet.className = 'fx-pb__sheet';
    bar.appendChild(sheet);
    rest.forEach(function (n) { sheet.appendChild(n); });

    pill.addEventListener('click', function () {
      var open = !bar.classList.contains('is-open');
      bar.classList.add('is-animating');
      bar.classList.toggle('is-open', open);
      pill.setAttribute('aria-expanded', open ? 'true' : 'false');
      window.clearTimeout(animTimer);
      animTimer = window.setTimeout(function () {
        bar.classList.remove('is-animating');
      }, 340);
    });

    bar.setAttribute('data-fx-brand', brand);

    // A rebuild that CHANGED brand gets an entrance. A rebuild that did not,
    // and the very first render, get nothing: an element that flinches every
    // time the year changes is worse than one that never moves.
    if (lastBrand && lastBrand !== brand) {
      card.classList.add('is-swapping');
      window.clearTimeout(swapTimer);
      swapTimer = window.setTimeout(function () {
        card.classList.remove('is-swapping');
      }, SWAP_MS);
    }
    lastBrand = brand;
  }

  function safeDecorate() {
    try { decorate(); } catch (e) {
      // Never leave the bar half rebuilt: drop our scaffold so the extension's
      // own markup is what the customer sees.
      var bar = document.querySelector(BAR);
      if (!bar) return;
      var card = bar.querySelector('.fx-pb__card');
      var sheet = bar.querySelector('.fx-pb__sheet');
      [card, sheet].forEach(function (box) {
        if (!box) return;
        [].slice.call(box.querySelectorAll('.ident-selwrap'))
          .forEach(function (w) { bar.appendChild(w); });
        box.remove();
      });
      bar.classList.remove('fx-pb', 'is-open', 'is-animating');
      bar.removeAttribute('data-fx-brand');
    }
  }

  // Committing a model is the moment a trailer has been "searched" without a
  // VIN. The extension only records VIN searches, so record this one here for
  // the header button to read.
  function recordPick() {
    var bar = document.querySelector(BAR);
    if (!bar) return;
    var model = valueOf(bar, 'model');
    if (!model) return;
    try {
      window.localStorage.setItem(PICK_KEY, JSON.stringify({
        modelName: model,
        modelYear: valueOf(bar, 'year'),
        rangeName: valueOf(bar, 'range'),
        timestamp: new Date().toISOString()
      }));
      document.dispatchEvent(new CustomEvent('fx:trailer-changed'));
    } catch (e) { /* private mode, nothing to do */ }
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('[data-ident-find]')) recordPick();
  }, true);

  var observing = false;
  function boot() {
    var bar = document.querySelector(BAR);
    if (!bar) return;
    safeDecorate();
    if (!observing) {
      observing = true;
      new window.MutationObserver(safeDecorate).observe(bar, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The bar is rendered by the extension, which may not have run yet.
  var tries = 0;
  var wait = setInterval(function () {
    tries++;
    if (document.querySelector(BAR + ' [data-ident-chip]')) {
      clearInterval(wait);
      boot();
    } else if (tries > 40) {
      clearInterval(wait);
    }
  }, 250);
})();
